/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import FlipProfilePhoto from '../../components/FlipProfilePhoto';
import { FormatColumns, formatColumns } from './utils';
import Count from './Count';
import { OrgChart } from '../../types';
import { getActive } from './data';

interface DirectReportsProps {
  active: string;
  value: OrgChart;
  onClick: (id: string) => void;
}

const columnId = (column: FormatColumns[]) => {
  const text = column.map((item) => (item.report.id)).reduce((prev, current) => (`${prev}:${current}`), '');
  return text;
};

export default function DirectReports({ active, value, onClick }: DirectReportsProps) {
  const current = getActive(active, value);

  const getReports = (id: string) => {
    const user = value.orgChart[id];
    return (user.reports || []).length;
  };

  const handleClick = (id: string) => () => {
    onClick(id);
  };

  const columns = formatColumns(current.reports, value).filter((c) => (c.length));

  return (
    <div className="orgchart-directreports">
      {
        columns.map((column) => (
          <div key={columnId(column)} className="orgchart-directreports-col">
            {
              column.map(({ report, subreports }) => (
                <div key={report.id} className="orgchart-directreport">
                  <div className="orgchart-card">
                    <div className="orgchart-card-info-count" onClick={handleClick(report.id)}>
                      <div className="orgchart-card-info">
                        <div className="orgchart-card-info-photo">
                          <FlipProfilePhoto
                            firstName={report.firstName}
                            lastName={report.lastName}
                            id={report.id}
                          />
                        </div>
                        <div className="orgchart-card-info-profile">
                          <h1>{`${report.firstName} ${report.lastName}`}</h1>
                          <h2>{report.title}</h2>
                        </div>
                      </div>
                      <Count total={getReports(report.id)} />
                    </div>
                    <div className="orgchart-secondaryreports">
                      {
                        subreports.map((sreport) => (
                          <div key={sreport.id} className="orgchart-card">
                            <div className="orgchart-card-info-count" onClick={handleClick(sreport.id)}>
                              <div className="orgchart-card-info">
                                <div className="orgchart-card-info-photo">
                                  <FlipProfilePhoto
                                    firstName={sreport.firstName}
                                    lastName={sreport.lastName}
                                    id={sreport.id}
                                  />
                                </div>
                                <div className="orgchart-card-info-profile">
                                  <h1>{`${sreport.firstName} ${sreport.lastName}`}</h1>
                                  <h2>{sreport.title}</h2>
                                </div>
                              </div>
                              <Count total={getReports(sreport.id)} />
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
              ))
            }
          </div>
        ))
      }
    </div>
  );
}
